import React, { useContext, useEffect } from "react";
import styled from "styled-components";
import Axios from "axios";
import Web3 from "web3";
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";

import AdminSideBar from "../../Components/Admin/AdminSideBar";
import GlobalContext from "../../Hooks/globalContext";
import { NODE_ENDPOINT } from "../../Utils/constants";
import "../../Styles/pagination.css";
import useState from "../../Hooks/useState";
import languagePack from "../../Utils/language";
import AdminHeader from "../../Components/Admin/AdminHeader";
// import QnaPage from "../../Components/Admin/Pages/QnaPage";
// import SendLogPage from "../../Components/Admin/Pages/SendLogPage";
// import ChargeLogPage from "../../Components/Admin/Pages/ChargeLogPage";
import UserPage from "../../Components/Admin/Pages/UserPage";
import LogPage from "../../Components/Admin/Pages/LogPage";
import ConfigPage from "../../Components/Admin/Pages/ConfigPage";
import NoticePage from "../../Components/Admin/Pages/NoticePage";
import WritePage from "../../Components/Admin/Pages/WritePage";

// import PushPage from "../../Components/Admin/Pages/PushPage";
// import InputPage from "../../Components/Admin/Pages/InputPage";
// import MatchingLogPage from "../../Components/Admin/Pages/MatchingLogPage";
// import NoticePage from "../../Components/Admin/Pages/NoticePage";
// import WritePage from "../../Components/Admin/Pages/WritePage";

const Admin = styled.div`
  display: flex;
  height: 100%;
`;

const Main = styled.div`
  width: calc(100% - 250px);
  background-color: ${(props) => props.theme.lightGrey};
`;

const ContentWrapper = styled.div`
  width: 100%;
  height: calc(100% - 90px);
  padding: 0px 20px 20px 20px;
`;

const Content = styled.div`
  background-color: white;
  width: 100%;
  height: 100%;
  border-radius: 10px;
  padding: 10px 15px;
  display: flex;
  flex-direction: column;
`;

const Container = ({ history, location }) => {
  const { isLogin, user, getUser, logout, language } = useContext(GlobalContext);
  const page = useState("userList");
  const focus = useState(null);
  const preload = async () => {
    const _user = await getUser();
    if (_user === "expired") {
      return;
    }
    if (_user.is_admin === 0) {
      logout();
    }
  };
  useEffect(() => {
    preload();
  }, []);

  return (
    <Admin>
      {user.state && (
        <>
          <Helmet>
            <title>ADMIN</title>
          </Helmet>
          <AdminSideBar page={page} />
          <Main>
            <AdminHeader page={page.state} />
            <ContentWrapper>
              <Content>
                {page.state === "userList" && <UserPage adminPage={page} hostPath={"/admin/users"} />}
                {page.state === "noticeList" && (
                  <NoticePage adminPage={page} focus={focus} hostPath={"/admin/notice/list"} />
                )}
                {page.state === "noticeWrite" && <WritePage adminPage={page} hostPath={"/admin/notice/crud"} />}
                {page.state === "noticeUpdate" && (
                  <WritePage adminPage={page} type="update" focus={focus} hostPath={"/admin/notice/crud"} />
                )}
                {page.state === "lockupList" && (
                  <LogPage
                    adminPage={page}
                    tableName="lock_up"
                    columnName="lockupList"
                    searchList={[
                      ["id", languagePack("번호", language.state)],
                      ["user_id", languagePack("유저 번호", language.state)],
                    ]}
                  />
                )}
                {page.state === "stakingList" && (
                  <LogPage
                    adminPage={page}
                    tableName="staking"
                    columnName="stakingList"
                    searchList={[
                      ["id", languagePack("번호", language.state)],
                      ["user_id", languagePack("유저 번호", language.state)],
                      [
                        "status",
                        languagePack("유저 번호", language.state) +
                          `(0:${languagePack("미지급", language.state)}, 1:${languagePack("지급", language.state)})`,
                      ],
                    ]}
                  />
                )}
                {page.state === "config" && <ConfigPage adminPage={page} />}

                {/* {page.state === "chargeLog" && <ChargeLogPage adminPage={page} hostPath={"/admin/log/charge"} />}
                {page.state === "sendLog" && <SendLogPage adminPage={page} hostPath={"/admin/log/send"} />}
                {page.state === "matchingLog" && <MatchingLogPage adminPage={page} hostPath={"/admin/log/matching"} />}
                {page.state === "withdraw" && <WithdrawPage adminPage={page} hostPath={"/admin/withdraw"} />}
                {page.state === "noticeList" && (
                  <NoticePage adminPage={page} focus={focus} hostPath={"/admin/notice/list"} />
                )}
                {page.state === "noticeWrite" && <WritePage adminPage={page} hostPath={"/admin/notice/crud"} />}
                {page.state === "noticeUpdate" && (
                  <WritePage adminPage={page} type="update" focus={focus} hostPath={"/admin/notice/crud"} />
                )}
                {page.state === "push" && <PushPage adminPage={page} />}
                {page.state === "input" && <InputPage adminPage={page} />}
                {page.state === "qna" && <QnaPage adminPage={page} hostPath={"/admin/qna"} />} */}
              </Content>
            </ContentWrapper>
          </Main>
        </>
      )}
    </Admin>
  );
};

export default Container;
